export const avgOfKeys = (obj, keys) => {
    const vals = keys
      .map((k) => Number(obj?.[k]))
      // Exclude non-finite values and zeros from average calculation
      .filter((v) => Number.isFinite(v) && v !== 0);
    if (!vals.length) return 0;
    const avg = vals.reduce((a, b) => a + b, 0) / vals.length; // 1..7 scale
    // Map 1..7 to 0..100 (1 -> 0%, 7 -> 100%)
    return ((avg - 1) / 6) * 100;
  };